








import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { HikariConfig } from '@/data/hikariConfig';

import SideBar from '@/components/Templates/FixedBarForSmartDevice.vue';
import UrlMixin from '@/mixins/url';

@Component({
  components: { SideBar },
})
export default class SpSideBar extends mixins(UrlMixin) {
  @Prop() config!: HikariConfig;

  get initialTotalAmount(): number {
    return (
      Number(this.$store.getters['vas/initialTotalAmount']) +
      Number(this.$store.getters['hikari/initialTotalAmount'](this.config))
    );
  }

  get totalAmountOfMonth(): number {
    return (
      Number(this.$store.getters['vas/totalAmountOfMonth']) +
      Number(this.$store.getters['hikari/totalAmountOfMonth'](this.config))
    );
  }
}
